import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ChartModule } from 'angular-highcharts';
import { SharedModule } from '../shared/shared.module';

import {
  DashboardComponent,
  PanelComponent
} from './';

import { EquipmentsModule } from './equipments/equipments.module';
import { InvoiceModule } from './invoice/invoice.module';
import { ServicesModule } from './services/services.module';
import { ServiceProvidersModule } from './service-providers/service-providers.module';
import { ServiceOrderModule } from './service-order/service-order.module';
import { ServiceOrderManagementModule } from './service-order-management/service-order-management.module';
import { ReportsModule } from './reports/reports.module';
import { SupervisorModule } from './supervisor/supervisor.module';

import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

registerLocaleData(localePt);

@NgModule({
  declarations: [
    DashboardComponent,
    PanelComponent
  ],
  imports: [
    ChartModule,
    CommonModule,
    EquipmentsModule,
    InvoiceModule,
    ReportsModule,
    RouterModule,
    ServiceOrderManagementModule,
    ServiceOrderModule,
    ServiceProvidersModule,
    ServicesModule,
    SharedModule,
    SupervisorModule
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR'
    }
  ]
})
export class PanelModule { }
